import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {
    InvoiceByIdRequest,
    InvoiceDTO,
    InvoicePdfRequest,
    InvoiceSearchRequest,
    InvoicesSummaryDTO,
    InvoicesSummaryRequest,
    PageInvoiceDTO,
    PageRevenueInvoiceDTO,
    RevenueInvoicePdfRequest,
    RevenueInvoiceSearchRequest,
} from 'src/types';
import {getBaseURL} from 'src/utils/helper';

export const invoicesApi = createApi({
    reducerPath: 'invoicesApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL()),
    }),
    endpoints: (build) => ({
        getInvoices: build.query<PageInvoiceDTO, InvoiceSearchRequest>({
            query: ({data, params}) => ({url: '/invoices/search', method: 'post', data, params}),
        }),
        getInvoiceById: build.query<InvoiceDTO, InvoiceByIdRequest>({
            query: ({invoiceId, businessId, userId, companyId, realEstateId}) => ({
                url: `/invoices/${invoiceId}`,
                method: 'get',
                params: {businessId, userId, companyId, realEstateId},
            }),
        }),
        getInvoicesSummary: build.query<InvoicesSummaryDTO, InvoicesSummaryRequest>({
            query: (data) => ({url: '/invoices/summary', method: 'post', data}),
        }),
        getInvoicesByBusinesses: build.query<PageRevenueInvoiceDTO, RevenueInvoiceSearchRequest>({
            query: ({data, params}) => ({
                url: '/revenue_invoices/search',
                method: 'post',
                data,
                params,
            }),
        }),
        getInvoicePdf: build.query<string, InvoicePdfRequest>({
            query: ({businessId, invoiceId, userId}) => ({
                url: `/invoices/${invoiceId}/pdf`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                responseType: 'blob',
                params: {businessId, userId},
            }),
            transformResponse(baseQueryData) {
                if (baseQueryData instanceof Blob) {
                    return URL.createObjectURL(baseQueryData);
                }
                return '';
            },
        }),
        revenueInvoicePdf: build.query<string, RevenueInvoicePdfRequest>({
            query: ({businessId, invoiceId}) => ({
                url: `/revenue_invoices/${invoiceId}/pdf`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                responseType: 'blob',
                params: {businessId},
            }),
            transformResponse(baseQueryData) {
                if (baseQueryData instanceof Blob) {
                    return URL.createObjectURL(baseQueryData);
                }
                return '';
            },
        }),
    }),
});
